var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("div", [
          _c("p", {
            staticClass: "icon-jujue closeBtn",
            on: { click: _vm.routerBack },
          }),
        ]),
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-row",
              { attrs: { type: "flex", align: "middle" } },
              [
                _vm.statusView == "S"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROD_MEDUSAGE_SAVE,
                            expression: "RMC_PROD_MEDUSAGE_SAVE",
                          },
                        ],
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.saveData("detailInfo")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    )
                  : _vm._e(),
                _vm.statusView == "S"
                  ? _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROD_MEDUSAGE_SUBMIT,
                            expression: "RMC_PROD_MEDUSAGE_SUBMIT",
                          },
                        ],
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitData("detailInfo")
                          },
                        },
                      },
                      [_vm._v("提交")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-form",
          {
            ref: "detailInfo",
            staticClass: "searchForm",
            attrs: {
              model: _vm.detailInfo,
              rules: _vm.rules,
              "label-position": _vm.labelPosition,
              "label-width": "120px",
            },
          },
          [
            _c(
              "div",
              { staticClass: "handle-box" },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("基本信息"),
                    ]),
                  ]
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "报告期限", prop: "reportDate" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.reportDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.detailInfo, "reportDate", $$v)
                                  },
                                  expression: "detailInfo.reportDate",
                                },
                              },
                              _vm._l(_vm.allDate, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "Farm", prop: "rmcProduceFarmId" },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getFarmGroupId },
                                model: {
                                  value: _vm.detailInfo.rmcProduceFarmId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "rmcProduceFarmId",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.rmcProduceFarmId",
                                },
                              },
                              _vm._l(_vm.farmList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.farmName,
                                    value: item.rmcProduceFarmId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "供应商" } },
                          [
                            _c("el-input", {
                              attrs: { disabled: "", maxlength: "100" },
                              model: {
                                value: _vm.detailInfo.sponsorName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "sponsorName", $$v)
                                },
                                expression: "detailInfo.sponsorName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Category3" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.category3List.length > 1 &&
                                    _vm.statusView == "S"
                                      ? false
                                      : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                on: { change: _vm.getCategory3Name },
                                model: {
                                  value: _vm.detailInfo.category3Code,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "category3Code",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.category3Code",
                                },
                              },
                              _vm._l(_vm.category3List, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.object,
                                    value: item.key,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "作物", prop: "cultiVarName" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled:
                                    _vm.statusView == "S" ? false : true,
                                  clearable: "",
                                  placeholder: "请选择",
                                },
                                model: {
                                  value: _vm.detailInfo.cultiVarName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.detailInfo,
                                      "cultiVarName",
                                      $$v
                                    )
                                  },
                                  expression: "detailInfo.cultiVarName",
                                },
                              },
                              _vm._l(_vm.cropList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.name, value: item.code },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "种植亩数", prop: "plantUnit" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "10",
                                disabled: _vm.statusView == "S" ? false : true,
                                oninput:
                                  "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                                placeholder: "请输入内容",
                              },
                              on: { blur: _vm.setDosage },
                              model: {
                                value: _vm.detailInfo.plantUnit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "plantUnit", $$v)
                                },
                                expression: "detailInfo.plantUnit",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "亩产量(kg)", prop: "yield" } },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "10",
                                disabled: _vm.statusView == "S" ? false : true,
                                oninput:
                                  "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                                placeholder: "请输入内容",
                              },
                              on: { blur: _vm.setDosage },
                              model: {
                                value: _vm.detailInfo.yield,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "yield", $$v)
                                },
                                expression: "detailInfo.yield",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "实际使用量(kg)", prop: "realUse" },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "10",
                                disabled: "",
                                oninput:
                                  "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,4})?).*$/g, '$1')",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.realUse,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "realUse", $$v)
                                },
                                expression: "detailInfo.realUse",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "农药原粉量总量(g)/种植亩数(亩)",
                              prop: "pesticideUnit",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "10",
                                disabled: "",
                                oninput:
                                  "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,4})?).*$/g, '$1')",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.pesticideUnit,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "pesticideUnit", $$v)
                                },
                                expression: "detailInfo.pesticideUnit",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "农药原粉量总量(g)/(亩产量*种植亩数)(ton)",
                              prop: "pesticideUnitTotal",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                maxlength: "10",
                                disabled: "",
                                oninput:
                                  "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,4})?).*$/g, '$1')",
                                placeholder: "请输入内容",
                              },
                              model: {
                                value: _vm.detailInfo.pesticideUnitTotal,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailInfo,
                                    "pesticideUnitTotal",
                                    $$v
                                  )
                                },
                                expression: "detailInfo.pesticideUnitTotal",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_RMC_PRODUCE_MEDICINE_USAGE",
                                disabled: "",
                                filterable: "",
                                field: "STATUS",
                                clearable: "",
                              },
                              model: {
                                value: _vm.detailInfo.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.detailInfo, "status", $$v)
                                },
                                expression: "detailInfo.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "handle-box",
                staticStyle: { "margin-top": "20px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("药品用量明细"),
                    ]),
                  ]
                ),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-top": "10px" },
                    attrs: { type: "flex", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROD_MEDUSAGE_ITEM_UPDATE,
                            expression: "RMC_PROD_MEDUSAGE_ITEM_UPDATE",
                          },
                        ],
                        staticClass: "btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.addInventory },
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "acl",
                            rawName: "v-acl",
                            value: _vm.RMC_PROD_MEDUSAGE_ITEM_UPDATE,
                            expression: "RMC_PROD_MEDUSAGE_ITEM_UPDATE",
                          },
                        ],
                        staticClass: "btn",
                        attrs: {
                          disabled:
                            _vm.multipleSelection.length > 0 ? false : true,
                          type: "danger",
                        },
                        on: { click: _vm.delRow },
                      },
                      [_vm._v("删除")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    ref: "plxTable",
                    staticStyle: { "margin-top": "10px" },
                    attrs: {
                      data: _vm.detailInfo.amountList,
                      "max-height": "500",
                      "show-overflow": "ellipsis",
                      "highlight-current-row": "",
                    },
                    on: { "selection-change": _vm.selectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        sortable: "",
                        type: "selection",
                        width: "55",
                        align: "center",
                        fixed: "left",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "商品名",
                        width: "120",
                        prop: "productName",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onDownload(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.productName))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "用途分类",
                        align: "center",
                        width: "120",
                        prop: "useClass",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "生产厂家",
                        align: "center",
                        width: "130",
                        prop: "producer",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "有效成分",
                        align: "center",
                        "show-overflow-tooltip": "",
                        prop: "effectiveComponents",
                      },
                    }),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: "净含量(%)(有效成分含量)",
                          align: "center",
                          width: "140",
                          prop: "netRate",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "",
                                      prop:
                                        "amountList." +
                                        scope.$index +
                                        ".netRate",
                                      rules: _vm.rules.netRate,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.statusView == "S" ? false : true,
                                        placeholder: "请输入内容",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.setNetUsage(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.netRate,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "netRate", $$v)
                                        },
                                        expression: "scope.row.netRate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _c("span", [_vm._v("净含量(%)(有效成分含量)")]),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: "使用量(kg)",
                          align: "center",
                          width: "130",
                          prop: "usage",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "",
                                      prop:
                                        "amountList." + scope.$index + ".usage",
                                      rules: _vm.rules.usage,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.statusView == "S" ? false : true,
                                        oninput:
                                          "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                                        placeholder: "请输入内容",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.setNetUsage(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.usage,
                                        callback: function ($$v) {
                                          _vm.$set(scope.row, "usage", $$v)
                                        },
                                        expression: "scope.row.usage",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _c("span", [_vm._v("使用量(kg)")]),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: "使用次数",
                          align: "center",
                          width: "130",
                          prop: "usageNumber",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "",
                                      prop:
                                        "amountList." +
                                        scope.$index +
                                        ".usageNumber",
                                      width: "130",
                                      rules: _vm.rules.usageNumber,
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        disabled:
                                          _vm.statusView == "S" ? false : true,
                                        oninput:
                                          "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')",
                                        placeholder: "请输入内容",
                                      },
                                      on: {
                                        blur: function ($event) {
                                          return _vm.setNetUsage(scope.row)
                                        },
                                      },
                                      model: {
                                        value: scope.row.usageNumber,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "usageNumber",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.usageNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v("*"),
                          ]),
                          _c("span", [_vm._v("使用次数")]),
                        ]),
                      ],
                      2
                    ),
                    _c("el-table-column", {
                      attrs: {
                        label: "换算原粉量(kg)(使用量*净含量%)",
                        width: "180",
                        align: "center",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                { attrs: { label: "" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      placeholder: "请输入内容",
                                    },
                                    model: {
                                      value: scope.row.netUsage,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "netUsage", $$v)
                                      },
                                      expression: "scope.row.netUsage",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "提示",
              visible: _vm.dialogVisible,
              width: "80%",
              "before-close": _vm.handleClose,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass: "header-title",
                attrs: { slot: "title" },
                slot: "title",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info_box_title",
                    staticStyle: {
                      "padding-left": "10px",
                      "box-sizing": "border-box",
                    },
                  },
                  [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "info_title" }, [
                      _vm._v("药品清单"),
                    ]),
                  ]
                ),
              ]
            ),
            _vm.dialogVisible
              ? _c("inventoryList", { on: { close: _vm.handleClose } })
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }